module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-0921.4f6c57ee.jpg";